import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, Table } from "reactstrap";
import moment from "moment";

import { withNamespaces } from "react-i18next";

//Import Image
import logo from "../assets/images/logo-light.png";
import { formatUnitsForReport } from "../helpers/units";
const PurchaseOrder = (props) => {  
  // function printInvoice() {
  //   window.print();
  // }
  // function printInvoice() {
  //   const containerElement = document.getElementsByClassName("page-content")[0];
  //   containerElement.scrollIntoView({ behavior: "smooth", block: "start" });
  //   setTimeout(() => {
  //     window.print();
  //   }, 500);
  // }
  function printInvoice() {
    const containerElement = document.getElementsByClassName("page-content")[0];
    const style = document.createElement("style");
    style.innerHTML = `
      .table thead th {
        background-color: #000 !important; 
        color: #fff !important; 
        -webkit-print-color-adjust: exact; 
      }     
    `;
    document.head.appendChild(style);
    // Scroll to the top of the page content
    containerElement.scrollIntoView({ behavior: "smooth", block: "start" });
  
    setTimeout(() => {
      document.title = `${props.purchase_order?.supplier?.name}_${props.purchase_order?.po_id}_${props.purchase_order?.branch_details?.name}`
      window.print();
      document.head.removeChild(style);
    }, 500);
  }

  const style = {
    top: 0,
    position: "sticky",
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                <div className="d-flex justify-content-between align-items-start mb-4">
  <div>
    <img src={logo} alt="logo" height="35" />
  </div>
  <div className="text-end">
    <h3 className="fw-bold">{props.t("PURCHASE ORDER")}</h3>
    <p className="mb-1">
      <strong>{props.t("PO #")}:</strong> {props.purchase_order?.po_id}
    </p>
    <p className="mb-0">
      <strong>{props.t("Date")}:</strong> {moment(props.purchase_order?.createdAt).format("DD/MM/YYYY")}
    </p>
  </div>
</div>

                  <Row className="mb-4">
                    <Col md="6" sm="6" lg="6" className="mb-4 mb-md-0">
                      <div className="invoice-info-card">
                        <h5 className="text-primary border-bottom pb-2 mb-3">{props.t("VENDOR INFORMATION")}</h5>
                        <div className="mb-1">
                          <span className="text-muted">{props.t("VENDOR NAME")}: </span>
                          <strong>
                            {props.purchase_order &&
                              props.purchase_order?.supplier?.name}
                          </strong>
                        </div>
                        <div className="mb-1">
                          <span className="text-muted">{props.t("SALES PERSON")}: </span>
                          <strong>
                            {props.purchase_order &&
                              props.purchase_order.supplier?.contact_person}
                          </strong>
                        </div>
                        <div className="mb-1">
                          <span className="text-muted">{props.t("ADDRESS")}: </span>
                          <strong>
                            {props.purchase_order &&
                              props.purchase_order.supplier?.address}
                          </strong>
                        </div>
                        <div className="mb-1">
                          <span className="text-muted">{props.t("CONTACT NO")}: </span>
                          <strong>
                            {props.purchase_order &&
                              props.purchase_order.supplier?.mobile}
                          </strong>
                        </div>
                        <div className="mb-1">
                          <span className="text-muted">{props.t("EMAIL")}: </span>
                          <strong>
                            {props.purchase_order &&
                              props.purchase_order.supplier?.email}
                          </strong>
                        </div>
                      </div>
                    </Col>

                    <Col md="6" sm="6" lg="6">
                      <div 
                        className="invoice-info-card"
                        hidden={!(props.purchase_order.deliver_at_branch || 
                          props.purchase_order.deliver_at_mainstore || 
                          props.purchase_order.deliver_at_substore)}
                      >
                        <h5 className="text-primary border-bottom pb-2 mb-3">{props.t("DELIVERY ADDRESS")}</h5>
                        <div className="mb-1">
                          <span className="text-muted">{props.t("CUSTOMER NAME")}: </span>
                          <strong>
                            {
                              props.purchase_order &&
                              (props.purchase_order.deliver_at_branch ||
                              props.purchase_order.deliver_at_mainstore ||
                              props.purchase_order.deliver_at_substore) &&
                              props.purchase_order.branch_details?.name
                            }
                          </strong>
                        </div>
                        <div className="mb-1">
                          <span className="text-muted">{props.t("ADDRESS")}: </span>
                          <strong>
                            {
                              props.purchase_order &&
                              (props.purchase_order.deliver_at_branch ||
                              props.purchase_order.deliver_at_mainstore ||
                              props.purchase_order.deliver_at_substore) &&
                              props.purchase_order.branch_details?.address
                            }
                          </strong>
                        </div>
                        <div className="mb-1">
                          <span className="text-muted">{props.t("CONTACT NO")}: </span>
                          <strong>
                            {
                              props.purchase_order &&
                              (props.purchase_order.deliver_at_branch ||
                              props.purchase_order.deliver_at_mainstore ||
                              props.purchase_order.deliver_at_substore) &&
                              props.purchase_order.branch_details?.mobile
                            }
                          </strong>
                        </div>
                        <div className="mb-1">
                          <span className="text-muted">{props.t("EMAIL")}: </span>
                          <strong>
                            {
                              props.purchase_order &&
                              (props.purchase_order.deliver_at_branch ||
                              props.purchase_order.deliver_at_mainstore ||
                              props.purchase_order.deliver_at_substore) &&
                              props.purchase_order.branch_details?.email
                            }
                          </strong>
                        </div>
                      </div>

                      <div 
                        className="invoice-info-card"
                        hidden={(props.purchase_order.deliver_at_branch || 
                          props.purchase_order.deliver_at_mainstore || 
                          props.purchase_order.deliver_at_substore)}
                      >
                        <h5 className="text-primary border-bottom pb-2 mb-3">{props.t("DELIVERY ADDRESS")}</h5>
                        <div className="mb-1">
                          <span className="text-muted">{props.t("CUSTOMER NAME")}: </span>
                          <strong>KARAK MQANES</strong>
                        </div>
                        <div className="mb-1">
                          <span className="text-muted">{props.t("PURCHASE MANAGER")}: </span>
                          <strong>MR MOIN MUNAWER</strong>
                        </div>
                        <div className="mb-1">
                          <span className="text-muted">{props.t("ADDRESS")}: </span>
                          <strong>
                            GWC Bu Fesseela Warehousing Park,
                            VA 8-5 (A) OPP TO EMDADCO FOOD STUFF
                          </strong>
                        </div>
                        <div className="mb-1">
                          <span className="text-muted">{props.t("CONTACT NO")}: </span>
                          <strong>77234663</strong>
                        </div>
                        <div className="mb-1">
                          <span className="text-muted">{props.t("EMAIL")}: </span>
                          <strong>purchase@karakmqanes.com</strong>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  {props.purchase_order &&
                    props.purchase_order.items  &&
                    props.purchase_order.items.length > 0 ? (
                    <>
                      <div className="py-2 mt-3">
                        <h3 className="font-size-15 font-weight-bold">
                          {props.t("Items")}
                        </h3>
                      </div>
                      <div className="table-responsive">
                        <Table className="table-nowrap">
                          <thead style={style}>
                            <tr>
                              <th>{props.t("Name")}</th>
                              <th>{props.t("Category")}</th>
                              <th className="text-right">{props.t("Price")}</th>
                              <th className="text-right">{props.t("Quantity")}</th>
                              <th className="text-right">
                                {props.t("Total Price")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {props.purchase_order &&
                              props.purchase_order.items.map((item, key) => (
                                <tr>
                                  <td>{item.name}</td>
                                  <td>{item.category}</td>
                                  <td className="text-right">{item.price}/{item.unit_for_po}</td>
                                  <td className="text-right">
                                    {formatUnitsForReport(item.quantity)}
                                    {/* {item.quantity && item.quantity.map((unitObj, index) => (
                                      <span key={index}>
                                        {(unitObj.value) + " " + (unitObj.unit)} &nbsp;
                                      </span>
                                    ))} */}
                                    {/* {`${item.quantity.in_unit} ${item.unit}`} */}
                                  </td>
                                  <td className="text-right">
                                    {(item.total_price).toFixed(2)}
                                  </td>
                                </tr>
                              ))}
                            <tr>
                              <td colSpan="4" className="border-0 text-right">
                                <strong>{props.t("Total")}</strong>
                              </td>
                              <td className="border-0 text-right">
                                {props.purchase_order &&
                                  props.purchase_order.items.reduce(
                                    (accumulator, currentValue) =>
                                      +accumulator + +currentValue.total_price,
                                    0
                                  ).toFixed(2)}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </>
                  ) : (
                    <>
                    <div className="py-2 mt-3">
                      <h3 className="font-size-15 font-weight-bold">
                        {props.t("Equipments")}
                      </h3>
                    </div>
                    <div className="table-responsive">
                      <Table className="table-nowrap">
                        <thead style={style}>
                          <tr>
                            <th>{props.t("Name")}</th>
                            <th>{props.t("Category")}</th>
                            <th className="text-right">
                              {props.t("Quantity")}
                            </th>
                            <th className="text-right">{props.t("Price")}</th>
                            <th className="text-right">
                              {props.t("Total Price")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {props.purchase_order &&
                            props.purchase_order.equipments.map((item, key) => (
                              <tr>
                                <td>{item.name}</td>
                                <td>{item.category}</td>
                                <td className="text-right">
                                 
                                  {`${item.quantity} ${item.unit}`}
                                </td>
                                <td className="text-right">{item.cost_price}/{item.unit}</td>
                                <td className="text-right">
                                  {item.total_price}
                                </td>
                              </tr>
                            ))}
                          <tr>
                            <td colSpan="4" className="border-0 text-right">
                              <strong>{props.t("Total")}</strong>
                            </td>
                            <td className="border-0 text-right">
                              {props.purchase_order &&
                                props.purchase_order.equipments.reduce(
                                  (accumulator, currentValue) =>
                                    +accumulator + +currentValue.total_price,
                                  0
                                )}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </>
                  )}

               {/* Delivery Details     */}
{props.purchase_order && props.purchase_order.delivery_details && props.purchase_order.delivery_details.length > 0 && (
  <>
  <div className="py-2 mt-3">
                        <h3 className="font-size-15 font-weight-bold">
                          {props.t("Delivery Details")}
                        </h3>
                      </div>
                      <div className="table-responsive">
                        <Table className="table-nowrap">
                          <thead style={style}>
                            <tr>
                              <th>{props.t("Name")}</th>
                              <th>{props.t("Category")}</th>
                              <th>{props.t("Free")}</th>
                              
                              <th className="text-right">{props.t("Receiving Date")}</th>
                              <th className="text-right">{props.t("Invoice")}</th>
                              <th className="text-right">{props.t("Price")}</th>
                              <th className="text-right">{props.t("Received")}</th>
                              <th className="text-right">
                                {props.t("Total Price")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {props.purchase_order &&
                              props.purchase_order.delivery_details.map((item, key) => (
                                <tr>
                                  <td>{item.name}</td>
                                  <td>{item.category}</td>
                                  <td>{item.free ? "Yes" : "No"}</td>
                                  
                                  <td className="text-right">{item.receiving_date ? moment(item.receiving_date).format("YYYY-MM-DD HH:mm") : " "}</td>
                                  <td className="text-right">{item.invoice_number}</td>
                                  <td className="text-right">{item.price}/{item.unit_for_po}</td>
                                  <td className="text-right">
                                    {formatUnitsForReport(item.receive)}
                                    {/* {item.receive && item.receive.map((unitObj, index) => (
                                      <span key={index}>
                                        {(unitObj.value) + " " + (unitObj.unit)} &nbsp;
                                      </span>
                                    ))} */}
                                    {/* {`${item.quantity.in_unit} ${item.unit}`} */}
                                  </td>
                                  <td className="text-right">
                                    {(item.total_price).toFixed(2)}
                                  </td>
                                </tr>
                              ))}
                            <tr>
                              <td colSpan="7" className="border-0 text-right">
                                <strong>{props.t("Total")}</strong>
                              </td>
                              <td className="border-0 text-right">
                                {props.purchase_order &&
                                  props.purchase_order.delivery_details.reduce(
                                    (accumulator, currentValue) =>
                                      +accumulator + +currentValue.total_price,
                                    0
                                  ).toFixed(2)}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
  </>
)}
                  <hr />
{/* Return Details  */}
{props.purchase_order && props.purchase_order.return_details && props.purchase_order.return_details.length > 0 && (
  <>
  <div className="py-2 mt-3">
                        <h3 className="font-size-15 font-weight-bold">
                          {props.t("Returned Items")}
                        </h3>
                      </div>
                      <div className="table-responsive">
                        <Table className="table-nowrap">
                          <thead style={style}>
                            <tr>
                              <th>{props.t("Name")}</th>
                              <th>{props.t("Category")}</th>
                              <th>{props.t("Free")}</th>
                              <th>{props.t("Return Order No.")}</th>
                              <th className="text-right">{props.t("Date of Return")}</th>
                              <th className="text-right">{props.t("Price")}</th>
                              <th className="text-right">{props.t("Quantity")}</th>
                              <th className="text-right">
                                {props.t("Total Price")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {props.purchase_order &&
                              props.purchase_order.return_details.map((item, key) => (
                                <tr>
                                  <td>{item.name}</td>
                                  <td>{item.category}</td>
                                  <td>{item.is_free ? "Yes" : "No"}</td>
                                  <td>{item.return_id}</td>
                                  <td className="text-right">{item.created_at ? moment(item.created_at).format("YYYY-MM-DD HH:mm") : " "}</td>
                                  <td className="text-right">{item.price}/{item.unit_for_po}</td>
                                  <td className="text-right">{formatUnitsForReport(item.quantity)}</td>
                                  <td className="text-right">{(item?.total_price).toFixed(2)}</td>
                                </tr>
                              ))}
                            <tr>
                              <td colSpan="7" className="border-0 text-right">
                                <strong>{props.t("Total")}</strong>
                              </td>
                              <td className="border-0 text-right">
                                {props.purchase_order &&
                                  props.purchase_order.return_details.reduce(
                                    (accumulator, currentValue) =>
                                      +accumulator + +currentValue?.total_price,
                                    0
                                  ).toFixed(2)}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
  </>
)}
<hr />
                  <Table className="table-nowrap">
                    <tbody>
                      <tr>
                        <td className="border-0 ">
                          <strong>{props.t("Additional Note")}</strong>
                        </td>
                        <td className="border-0 text-right">
                          <strong>{props.t("AUTHORIZE BY")}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">
                          {props.t(
                            "Payment shall be 30 days upon delivery of the above items."
                          )}
                        </td>
                        <td className="border-0 text-right"></td>
                      </tr>
                    </tbody>
                  </Table>
                  <div className="d-print-none">
                    <div className="float-right">
                      <Link
                        to="#"
                        onClick={() => {
                          printInvoice();
                        }}
                        className="btn btn-success waves-effect waves-light mr-2"
                      >
                        <i className="fa fa-print"></i> {props.t("Print")}
                      </Link>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withNamespaces()(PurchaseOrder);
